module.exports = __webpack_public_path__ + "static/media/underConstructionNew.36211a1f.svg";